"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
exports.default = CssBaseline_1.default;
